module.exports = __webpack_public_path__ + "ecf0a54f46a40efca1983f14dfc4be36.jpg";